export default "__VITE_ASSET__DzRPs5P8__"